<div class="recover-company-name">
  <div class="recover-company-name__header">
    <div class="recover-company-name__icon-background">
      <i class="fa-regular fa-building recover-company-name__icon"></i>
    </div>
    <div class="recover-company-name__title">{{ 'login.recovery.by-company-name.title' | translate }}</div>
  </div>

  @if (errorMessageTranslationKey(); as errorMessageTranslationKey) {
    <kds-banner typeIconPosition="baseline" [type]="BannerType.Error" [bannerText]="errorMessageTranslationKey | translate" />
  }

  <div class="recover-company-name__content">
    <div class="recover-company-name__description">{{ 'login.recovery.by-company-name.description' | translate }}</div>

    <div class="recover-company-name__input">
      <kds-input
        elementId="email"
        [label]="'login.recovery.controls.email' | translate"
        [componentFormControl]="recoveryForm.controls.userEmail"
      />
    </div>

    <div class="recover-company-name__buttons">
      <kds-large-button
        [buttonText]="'login.recovery.buttons.continue' | translate"
        [disabled]="recoveryForm.invalid"
        [loading]="loading()"
        (buttonClick)="recoverCredentials()"
      />
      <kds-large-button
        colorScheme="tertiary"
        [buttonText]="'login.recovery.buttons.back-to-login' | translate"
        (buttonClick)="backToLogin()"
      />
    </div>
  </div>
</div>
